import { Component, Host, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AnswerControlService } from '../../services/answer/answerControl.service';
import { AnswerService } from '../../services/answer/answer.service';
import { StateService } from "../../services/state/state.service";
import { LoginService } from '../../services/login/login.service';
import { TokenService } from "../../services/state/token.service";
import { TokenControlService } from "../../services/state/tokenControl.service";
import { Token } from "../../model/token";
import { TranslateService } from '@ngx-translate/core';
import { ConfigurationControlService } from "../../services/configuration/configurationControl.service";
import { ItemService } from '../../services/item/item.service';
import { RestService } from '../../services/rest/rest.service';
import { TimeChrono } from "../../model/timeChrono";
import { DeleteService } from "../../services/data/delete.service";
import { NgxSpinnerService } from 'ngx-spinner';
import { WelcomeService } from "../../services/welcome/welcome.service";
import { CONFIG } from '../../constants/constants';
import { LtiService } from '../../services/LTI/lti.service';
import { EstadoUsuarioService } from '../../services/estadoUsuario/estadoUsuario.service';

//Variable del global scope para utilizar jquery
declare var $: any;

@Component({
  selector: 'test-nav',
  templateUrl: './test-nav.component.html',
  styleUrls: ['./test-nav.component.css'],
  providers: [LoginService, TokenService]
})

//Controlador para el la navegacion del visualizador
export class TestNavComponent {

  //El token del usuario
  private token: Token;

  //Indica el numero de sesion que se va a cerrar
  private cierreSesion: number;

  public online: Boolean = CONFIG.ONLINE;

  //Indica si esta activa la integracion con sumadi
  public isSumadiActive: Boolean;

  public currentLanguage: string;

  //Constructor de la clase
  constructor(private _router: Router,
    public _answerController: AnswerControlService,
    private _stateService: StateService,
    private _loginService: LoginService,
    private _tokenController: TokenControlService,
    private _translateService: TranslateService,
    public _configurationControlService: ConfigurationControlService,
    private _restService: RestService,
    public _itemService: ItemService,
    private _answerService: AnswerService,
    private _spinner: NgxSpinnerService,
    private _deleteService: DeleteService,
    private _welcomeDataService: WelcomeService,
    private _ltiService: LtiService,
    private estadoUsuarioService: EstadoUsuarioService) {
    let self = this;
    self.token = _tokenController.token;
    this.isSumadiActive = this._configurationControlService.examConfiguration.securitySumadi;
    this._translateService.addLangs(["es", "en"]);
    this._translateService.setDefaultLang(_configurationControlService.examConfiguration.language);
    this.currentLanguage = _configurationControlService.examConfiguration.language || 'es';
    // this._translateService.use(_configurationControlService.examConfiguration.language);
    this._translateService.use(this.currentLanguage);
  }

  public isShowByRoleReview(): Boolean {
    return this._tokenController.isRoleReview() && this._itemService.activarReviewRole
  }


  //Metodo encargado de cerrar sesion
  public logout() {
    var URLactual = window.location;
    let self = this;
    this.saveTime();
    this.cierreSesion = Number(0);
    this._spinner.show();
    if (URLactual.pathname == "/viewtest") {
      if (this._tokenController.token.userType != 5) {
        this._answerService.saveOmision(this._configurationControlService.online).then(res => {
          self._deleteService.deleteDatabaseOnExit().then(result => {
            console.log('DELETE ITEMS DONE');
            self.navigate();
          });
        })
      } else {
        self._deleteService.deleteDatabaseOnExit().then(result => {
          console.log('DELETE ITEMS DONE');
          self.navigate();
        });
      }
    } else {
      self.navigate();
    }

    try {

      const token = this._tokenController.token;
      this._restService.eliminarRedisCache(token.token, token.tokenId).then(() => { });
    } catch (e) {
      console.log(e);
    }

  }

  //Método encargado de guardar el estado del cronometro
  public saveTime() {

    if (this._configurationControlService.examConfiguration.chrono && this._stateService.timeChrono) {
      let timeChrono = new TimeChrono(this._tokenController.token.credentialId, JSON.stringify(this._stateService.timeChrono), new Date(), this._stateService.state.sesion);
      this._restService.saveTestChrono(this._tokenController.token.token, timeChrono, this._tokenController.token.tokenId);
    }
  }

  //Método encargado de abrir el tour de ayuda
  public async goTour() {
    try {
      if (!(await this.estadoUsuarioService.getEstadoUsuario(this.token.tokenId, this.token.token))) {
        $('#finishUsuarioModal').modal({ show: 'true' });
        return false
      }
    } catch (e) { }

    this._configurationControlService.examConfiguration.showSimulation = false;
    this._configurationControlService.examConfiguration.showTerms = null;
    if (this._router.url.indexOf("/welcome") != -1) {
      this._configurationControlService.tourWelcome = true;
    }
    this._router.navigate(['/webTourOne']);
  }

  /**Encargado de validar hacia donde navegar */
  public navigate() {
    this._spinner.hide();
    if (this._configurationControlService.esDemo) {
      this._router.navigate([this._configurationControlService.urlActual]);
    } else {
      this.isSumadiActive && window.postMessage({ action: 'plexiSuspend' }, location.origin);
      this._ltiService.sumadiData = undefined;
      this._ltiService.idSessionStart = undefined;
      sessionStorage.setItem('uuidSesion', '');
      this._router.navigate(["/login"]);
      //window.location.reload();
    }
  }

  // Método para cambiar el idioma
  public changeLanguage(lang: string) {
    this.currentLanguage = lang;
    this._translateService.use(lang);
    this._configurationControlService.examConfiguration.language = lang;

    // Opcional: guardar en localStorage para persistencia
    localStorage.setItem('preferredLanguage', lang);
  }

  /**
   * Método que se encarga
   * @param sesion
   */
  public validarRedireccionamiento(sesion: any) {
    var URLactual = window.location;
    if (this._configurationControlService.examConfiguration.singleSession && URLactual.pathname == "/viewtest") {
      $('#headerModal').modal({ show: 'true' });
    } else {
      this.logout();
    }
  }

}
